import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

const NEXT = { open: "reviewing", reviewing: "resolved", resolved: "open" };
const LABEL = { open: "Open", reviewing: "Reviewing", resolved: "Resolved" };

export const IssuesTable = () => {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/issues").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const advance = async (i) => {
    await api.patch(`/admin/issues/${i.id}`, { status: NEXT[i.status] });
    toast.success(`Marked ${LABEL[NEXT[i.status]]}`); load();
  };
  return (
    <div className="luxury-card overflow-x-auto">
      <table className="w-full text-sm" data-testid="issues-table">
        <thead className="bg-secondary/60"><tr className="text-left">
          {["When", "Who", "Location", "Page", "Issue", "Status"].map((h) => <th key={h} className="px-5 py-3 label-eyebrow font-medium">{h}</th>)}
        </tr></thead>
        <tbody>
          {(rows || []).map((i) => (
            <tr key={i.id} className="border-t border-border align-top" data-testid={`issue-row-${i.id}`}>
              <td className="px-5 py-3 text-muted-foreground whitespace-nowrap">{new Date(i.created_at).toLocaleString()}</td>
              <td className="px-5 py-3">{i.user_name}<div className="text-xs text-muted-foreground">{i.role}</div></td>
              <td className="px-5 py-3">{i.location_name || "—"}</td>
              <td className="px-5 py-3 text-xs text-muted-foreground">{i.page}</td>
              <td className="px-5 py-3 max-w-md whitespace-pre-wrap">{i.description}</td>
              <td className="px-5 py-3">
                <button onClick={() => advance(i)} data-testid={`issue-status-${i.id}`}
                  className={`text-xs px-2.5 py-1 rounded-full border ${i.status === "resolved" ? "border-[hsl(var(--accent-sage))] text-[hsl(var(--accent-sage))]" : "border-border"}`}>
                  {LABEL[i.status]}
                </button>
              </td>
            </tr>
          ))}
          {rows && rows.length === 0 && <tr><td colSpan="6" className="px-5 py-12 text-center text-muted-foreground">No issues reported.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};
